<template>
  <b-carousel-slide class="carousel-background">
    <b-container fluid class="bv-example-row" id="proof">
      <b-row>
        <b-col sm="12" lg="5" class="text-center" id="proof1">
          <b-img :src="image" id="nimesh-img" fluid></b-img>
          <cq-paratext> <b> {{ name }} </b> <br> {{ designation }} </cq-paratext>
        </b-col>
        <b-col sm="12" lg="7" class="proof2"> 
          <cq-paratext v-for="(message, index) in messages"
                        :key="index">
                {{ message }}
          </cq-paratext>
              <cq-btn class="mb-4 mt-4">WATCH HOW</cq-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-carousel-slide>
</template>

<script>
import CQButton from '../../components/ui/CQButton.vue'
import CQPara from '../../components/ui/CQPara.vue'

// Import Image
import nimesh from '../../assets/image/home/nimesh.png'

export default {
  name: 'CQTestimonial',
  props : ['image', 'name', 'designation', 'messages'],
  components: {
    'cq-btn' : CQButton,
    'cq-paratext' : CQPara
  },
  data() {
    return {
      images: {
        nimesh
      }
    }
  }
}
</script>

<style scoped>
  #proof1 img{
    max-width: 50%;
    padding-bottom: 5%;
  }

  .proof2 p{
    text-align: left;
  }
</style>